import fetchAs from "./fetchAs";

export default async function handleForm({ body }) {
	return fetchAs({
		endpoint: "handle_form/send?_format=json",
		testing: true,
		extraParams: { useDefaultJsonApiPath: false, returnResponse: true },
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body,
	});
}
